import React, { useCallback, useEffect, useState } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import PlatformPosture from "@/components/landing/PlatformPosture";
import PlatformOverview from "@/components/landing/PlatformOverview";
import Strategies from "@/components/landing/Strategies";
import SelectiveCapitalPathways from "@/components/landing/SelectiveCapitalPathways";
import FundArchitecture from "@/components/landing/FundArchitecture";
import CreditBridge from "@/components/landing/CreditBridge";
import IndustrialEquity from "@/components/landing/IndustrialEquity";
import WhyNow from "@/components/landing/WhyNow";
import DownsideProtection from "@/components/landing/DownsideProtection";
import Perspectives from "@/components/landing/Perspectives";
import Partnership from "@/components/landing/Partnership";
import SeniorAdvisors from "@/components/landing/SeniorAdvisors";
import MidPageCTA from "@/components/landing/MidPageCTA";
import Stewardship from "@/components/landing/Stewardship";
import AnchorPartner from "@/components/landing/AnchorPartner";
import Governance from "@/components/landing/Governance";
import ServiceProviders from "@/components/landing/ServiceProviders";
import Newsroom from "@/components/landing/Newsroom";
import Offices from "@/components/landing/Offices";
import InvestorAccess from "@/components/landing/InvestorAccess";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import InvestorAccessModal from "@/components/landing/InvestorAccessModal";

const Home = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [defaultInterest, setDefaultInterest] = useState("investor");

  const openModal = useCallback((opts) => {
    if (opts && typeof opts === "object" && opts.interest) {
      setDefaultInterest(opts.interest);
    } else {
      setDefaultInterest("investor");
    }
    setModalOpen(true);
  }, []);

  const closeModal = useCallback(() => setModalOpen(false), []);

  // Scroll reveal observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("kr-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -6% 0px" }
    );
    const els = document.querySelectorAll("section");
    els.forEach((el) => {
      el.classList.add("kr-reveal");
      observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const scrollTo = useCallback((id) => {
    const el = document.getElementById(id);
    el && el.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <>
      <Navbar onRequestAccess={() => openModal()} />
      <main className="relative">
        <Hero
          onRequestAccess={() => openModal()}
          onExplore={() => scrollTo("platform")}
        />
        <PlatformPosture />
        <PlatformOverview />
        <Strategies />
        <SelectiveCapitalPathways
          onRequestAccess={(opts) => openModal(opts)}
        />
        <FundArchitecture />
        <CreditBridge />
        <IndustrialEquity />
        <WhyNow />
        <DownsideProtection />
        <Perspectives />
        <Partnership />
        <SeniorAdvisors />
        <MidPageCTA onRequestAccess={() => openModal()} />
        <Stewardship />
        <AnchorPartner
          onRequestAccess={() => openModal({ interest: "strategic" })}
        />
        <Governance />
        <ServiceProviders />
        <Newsroom />
        <Offices />
        <InvestorAccess
          onRequestAccess={(opts) => openModal(opts)}
          onScrollContact={() => scrollTo("contact")}
        />
        <Contact />
      </main>
      <Footer />

      <InvestorAccessModal
        open={modalOpen}
        onClose={closeModal}
        defaultInterest={defaultInterest}
      />
    </>
  );
};

export default Home;
